import { render, staticRenderFns } from "./AdvertisingAdd.vue?vue&type=template&id=23f713ee&scoped=true&"
import script from "./AdvertisingAdd.vue?vue&type=script&lang=js&"
export * from "./AdvertisingAdd.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingAdd.vue?vue&type=style&index=0&id=23f713ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f713ee",
  null
  
)

export default component.exports